const lmz744 = [
    [
        -87.183239599999993,
        41.723321400000003
    ],
    [
        -87.152736499999989,
        41.644664800000001
    ],
    [
        -87.156676099999984,
        41.644618299999998
    ],
    [
        -87.156829799999983,
        41.639392799999996
    ],
    [
        -87.15715019999999,
        41.639110499999994
    ],
    [
        -87.157180699999984,
        41.632835299999996
    ],
    [
        -87.160325999999984,
        41.632839999999995
    ],
    [
        -87.160240999999985,
        41.637344099999993
    ],
    [
        -87.174728299999984,
        41.634342099999991
    ],
    [
        -87.174674999999979,
        41.635156999999992
    ],
    [
        -87.17536149999998,
        41.635171899999989
    ],
    [
        -87.175231899999986,
        41.632835299999989
    ],
    [
        -87.179570999999981,
        41.631492999999992
    ],
    [
        -87.187650999999988,
        41.62965299999999
    ],
    [
        -87.190978999999984,
        41.629268599999989
    ],
    [
        -87.196159299999991,
        41.628131799999991
    ],
    [
        -87.19686879999999,
        41.628147099999993
    ],
    [
        -87.197379999999995,
        41.627921999999991
    ],
    [
        -87.201217599999993,
        41.627315499999987
    ],
    [
        -87.202210999999991,
        41.627347999999991
    ],
    [
        -87.203090999999986,
        41.627059999999993
    ],
    [
        -87.20873899999998,
        41.626211999999995
    ],
    [
        -87.209342899999982,
        41.625923099999994
    ],
    [
        -87.219787499999981,
        41.624370499999998
    ],
    [
        -87.222595199999986,
        41.624237000000001
    ],
    [
        -87.261535599999988,
        41.6203346
    ],
    [
        -87.270934999999994,
        41.619934000000001
    ],
    [
        -87.2873369,
        41.619535900000002
    ],
    [
        -87.287636800000001,
        41.622234300000002
    ],
    [
        -87.298437000000007,
        41.622736000000003
    ],
    [
        -87.324340800000002,
        41.623035400000006
    ],
    [
        -87.324138099999999,
        41.624534600000004
    ],
    [
        -87.324836700000006,
        41.624534600000004
    ],
    [
        -87.324981600000001,
        41.616996700000001
    ],
    [
        -87.324836700000006,
        41.615234300000004
    ],
    [
        -87.324338000000012,
        41.611336000000001
    ],
    [
        -87.32343800000001,
        41.610436
    ],
    [
        -87.32343800000001,
        41.609236000000003
    ],
    [
        -87.324637900000013,
        41.608835900000003
    ],
    [
        -87.325738000000015,
        41.609236000000003
    ],
    [
        -87.325538600000016,
        41.624534600000004
    ],
    [
        -87.327507000000011,
        41.624942700000005
    ],
    [
        -87.355538900000013,
        41.627636000000003
    ],
    [
        -87.358412000000015,
        41.628187199999999
    ],
    [
        -87.312761800000018,
        41.706685100000001
    ],
    [
        -87.308911100000017,
        41.706138299999999
    ],
    [
        -87.297521900000021,
        41.706008099999998
    ],
    [
        -87.295947000000027,
        41.705685899999999
    ],
    [
        -87.294585600000033,
        41.705924099999997
    ],
    [
        -87.28378560000003,
        41.705424099999995
    ],
    [
        -87.273688200000024,
        41.703171599999997
    ],
    [
        -87.267556900000017,
        41.703432499999998
    ],
    [
        -87.229493100000013,
        41.707171099999996
    ],
    [
        -87.222885800000014,
        41.708076999999996
    ],
    [
        -87.221153000000015,
        41.708558699999998
    ],
    [
        -87.217969000000011,
        41.709038700000001
    ],
    [
        -87.215712900000014,
        41.709207800000001
    ],
    [
        -87.214038700000017,
        41.709636700000004
    ],
    [
        -87.209929500000015,
        41.710307500000006
    ],
    [
        -87.207231800000017,
        41.712110100000004
    ],
    [
        -87.200765800000013,
        41.713396200000005
    ],
    [
        -87.188544800000017,
        41.721562100000007
    ],
    [
        -87.18469420000001,
        41.722349500000007
    ],
    [
        -87.183239599999993,
        41.723321400000003
    ]
];

export default lmz744;
